import script from "./Users.vue?vue&type=script&lang=ts&setup=true"
export * from "./Users.vue?vue&type=script&lang=ts&setup=true"

import "./Users.vue?vue&type=style&index=0&id=5db2d2c8&lang=scss&scoped=true"
script.__scopeId = "data-v-5db2d2c8"

export default script